import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Calendar, MapPin, User, Package } from 'lucide-react';

export const EventDetailsSection = ({ formData, onChange }) => {
  const minDate = new Date(Date.now() + 14 * 24 * 60 * 60 * 1000)
    .toISOString()
    .split('T')[0];

  return (
    <Card className="border-2 border-[#8B7355]/20">
      <CardHeader>
        <CardTitle className="font-serif text-2xl text-[#8B7355]">Event Details</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <Label htmlFor="event_date" className="flex items-center gap-2 text-[#8B7355] mb-2">
              <Calendar className="w-4 h-4" /> Event Date *
            </Label>
            <Input
              id="event_date"
              name="event_date"
              type="date"
              value={formData.event_date}
              onChange={onChange}
              required
              min={minDate}
              className="border-[#8B7355]/30"
              data-testid="booking-date-input"
            />
            <p className="text-xs text-[#8B7355]/60 mt-1">Minimum 2 weeks notice required</p>
          </div>

          <div>
            <Label htmlFor="event_type" className="flex items-center gap-2 text-[#8B7355] mb-2">
              <Package className="w-4 h-4" /> Event Type *
            </Label>
            <Input
              id="event_type"
              name="event_type"
              value={formData.event_type}
              onChange={onChange}
              placeholder="e.g., Wedding, Birthday, Corporate Event, Goodbye Party..."
              required
              className="border-[#8B7355]/30"
              data-testid="booking-event-type-input"
            />
            <p className="text-xs text-[#8B7355]/60 mt-1">What are you celebrating?</p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <Label htmlFor="guest_count" className="flex items-center gap-2 text-[#8B7355] mb-2">
              <User className="w-4 h-4" /> Expected Guests
            </Label>
            <Input
              id="guest_count"
              name="guest_count"
              type="number"
              value={formData.guest_count}
              onChange={onChange}
              placeholder="Optional"
              className="border-[#8B7355]/30"
              data-testid="booking-guest-count-input"
            />
          </div>

          <div>
            <Label htmlFor="event_location" className="flex items-center gap-2 text-[#8B7355] mb-2">
              <MapPin className="w-4 h-4" /> Event Location *
            </Label>
            <Input
              id="event_location"
              name="event_location"
              value={formData.event_location}
              onChange={onChange}
              placeholder="e.g., Brisbane City, Gold Coast, etc."
              required
              className="border-[#8B7355]/30"
              data-testid="booking-location-input"
            />
            <p className="text-xs text-[#8B7355]/60 mt-1">
              We'll do the first 50km on us, then $1.50/km after that
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
